// Start IG-SH-SEP-1042 Payment methods

$(document).ready(function(){
  setTimeout(function(){
  	//$('.laybuy_payment_method a.laybuy-link').append('<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>');
  	$('.afterpay_payment_method a.afterpay-link').append('<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>');
	$('.zip_payment_method #partPayCalculatorWidgetLearn').append('<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>');   
  },100);
  if ($(window).width() < 768) {
    const myNodelist = document.querySelectorAll('.ig-ptp-mobile .show-desktop .installment_price');
    if(myNodelist.length > 0){
      var min = 0; var I =0; 
      myNodelist.forEach(function(item,index){
        var match = item.innerText.match(/(\D+)?\d/);
        var index = match ? match[0].length-1 : -1;
        var value = item.innerText.substr(index,item.innerText.length);
        if(value < min) { min = value, I = index }
      });
      var textToDisplay = "Or Payment From " + myNodelist[I].innerText;
      document.querySelector('.payment_text').innerText = textToDisplay;
    }
  }
  
  // if($('.laybuy_payment_method .laybuy-text1').html() == ''){
  // 	$('.laybuy_payment_method').hide();
  // }
  
  if($('.afterpay_payment_method .afterpay-link').html() == ''){
  	$('.afterpay_payment_method').hide();
  }
  
  // if($('.genoapay_payment_method .genoapay-popup-trigger').html() == ''){
  // 	$('.genoapay_payment_method').hide();
  // }
  
  if($('.zip_payment_method #partPayCalculatorWidgetLearn').html() == ''){
  	$('.zip_payment_method').hide();
  } 

});
// Genoapay Payment
// $(document).ready(function(){
//   //$('#g-infomodal-container').hide();
// 	var popupTrigger = $('.genoapay-popup-trigger'),
//             popup        = $('#g-infomodal-container'),
//             closeBtn     = $('#g-infomodal-close');
 
//         $('.genoapay-popup-trigger').click(function(event){ 
//           console.log($(this).parents('#genoapay-popup').siblings('#g-infomodal-container'));
//           $(this).parents('#genoapay-popup').siblings('.g-infomodal-container').removeClass('hide-g-modal');
//         });
 
//       $('.g-infomodal-close').click(function(){
//         $(this).parents('.g-infomodal-container').addClass('hide-g-modal');
//       });
// });
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "NZ$";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }
  //console.log(formatString.match(placeholderRegex)[1]);
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
// code for description-with-accordian.liquid on PDP
var acc =  document.querySelectorAll('.accordion-container .accordion');
//var acc = document.getElementsByClassName("accordion");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      console.log(acc)
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
}
// code for description-with-accordian.liquid inner content show more on PDP
$(document).ready(function(){
    $(".full-less span").click(function(){
      $(this).parents(".coampitibility-gridview").toggleClass("show-fulldetails");
    });
	var screen_width = $(window).width();
	if(screen_width < 767){
      $(".listing-models").each(function(){
        if ($(this).find('li').length > 12 )
        {
          $(this).addClass('large-content').after( '<p class="listing-p"><span class="show-more-list">View all Models</span><span class="show-less-list">View less</span></p>' )
        }
      });
      
      $('.show-more-list').click(function(){
        $(this).parents('.listing-p').siblings('.large-content').addClass('active-listing');
        $(this).hide();
        $(this).siblings('.show-less-list').show();

      });
      $('.show-less-list').click(function(){
        $(this).parents('.listing-p').siblings('.large-content').removeClass('active-listing');
        $(this).hide();
        $(this).siblings('.show-more-list').show();

      });
	}
  else if(screen_width > 767){
      $(".listing-models").each(function(){
        if ($(this).find('li').length > 16 )
        {
          $(this).addClass('large-content').after( '<p class="listing-p"><span class="show-more-list">View all Models</span><span class="show-less-list">View less</span></p>' )
        }
      });
      
      $('.show-more-list').click(function(){
        $(this).parents('.listing-p').siblings('.large-content').addClass('active-listing');
        $(this).hide();
        $(this).siblings('.show-less-list').show();

      });
      $('.show-less-list').click(function(){
        $(this).parents('.listing-p').siblings('.large-content').removeClass('active-listing');
        $(this).hide();
        $(this).siblings('.show-more-list').show();

      });
	}
});
// code from product-details.js.liquid file for multiple implementations
$(document).ready(function(){
  // mobile sticky USP scroll
  $(".mob-featured-blocks a").on('click', function(e) {
    e.preventDefault();
    var target = $(this).attr('href');
    if ($('body').hasClass('stick-featured')){
      $('html, body').animate({                        
        scrollTop: ($(target).offset().top) - 152
      }, 1000);
    } else {
      $('html, body').animate({                        
        scrollTop: ($(target).offset().top) - 152
      }, 1000);
    }
  });

  // Add class when touch FBT section
  function sticky_relocate() {
    var window_top = $(window).scrollTop();
    var nav = $('#shopify-section-product-main-description');
    if (nav.length) {
       var div_top = $('#shopify-section-product-main-description').offset().top;
      if (window_top > div_top) {
        $('body').addClass('stick-featured');
      } else {
        $('body').removeClass('stick-featured');
      }
    }
  }
  $(function() {
    $(window).scroll(sticky_relocate);
    sticky_relocate();
  });
  
 // Add class when touch price to show fixed footer at mobile
  function sticky_relocate1() {
    var window_top = $(window).scrollTop();
    var nav1 = $('.show-mob-only #product-price');
    if (nav1.length) {
      var div_top = $('.show-mob-only #product-price').offset().top - 60;
      if (window_top > div_top) {
        $('body').addClass('showfixed-footer');
        //$('.product-add').detach(); 
      } else {
        $('body').removeClass('showfixed-footer');
        //$('.swatch').prepend('.product-add');
      }
    }
  }
  
  $(function() {
    $(window).scroll(sticky_relocate1);
    sticky_relocate1();
  });

  //fixed slider on left

  $(function() {
    var nav2 = $('#sidebar');
    if (nav2.length) {
      var top = $('#sidebar').offset().top - 130;
      var footTop = $('#shopify-section-product-features').offset().top - 130;

      var maxY = footTop - $('#sidebar').outerHeight();
      $(window).scroll(function(evt) {
        var y = $(this).scrollTop();
        if (y > top) {

          //Quand scroll, ajoute une classe ".fixed" et supprime le Css existant 
          if (y < maxY) {
            $('#sidebar').addClass('fixed').removeAttr('style');
          } else {

            //Quand la sidebar arrive au footer, supprime la classe "fixed" précèdement ajouté
            $('#sidebar').removeClass('fixed').css({
              position: 'absolute',
              top: (maxY - top) + 'px'
            });
          }
        } else {
          $('#sidebar').removeClass('fixed');
        }
      });
    }
  });
  //youtube popup
  $(".youtb-link").click(function(){
    $(".youtube-popup").addClass("show-video");
    $("body").addClass("no-scroll");
  });
   $(".cross-popup").click(function(){
      $('.video-inner iframe').each(function(index) {
        $(this).attr('src', $(this).attr('src'));
        return false;
      });
    $(".youtube-popup").removeClass("show-video");
       $("body").removeClass("no-scroll");
  });
});
  
$(document).ready(function(){
    $('div#choose_variants').hide();
    setTimeout(function(){$('.pd-crt span:last-child').attr('id', 'choose'); }, 600);
    
    $('span#choose').click(function(e){
    	$(this).parent('.pd-crt').siblings( "#choose_variants" ).toggle();
    });
    
    $('button#close').click(function(e){
    	$(this).parent('#choose_variants').hide();
    });
    //  $('#freq_bought_mob .slick-arrow').click(function(e){
    // 	$('#choose_variants').hide();
    // });
    
    $('.cart_btn').click(function(e){
    	$(this).parent('.pd-crt').siblings( "#choose_variants" ).hide();
    });
    
    $('.fbt-option-0').change(function(){
      console.log('here',$('input[name=option-0]:checked').val());
    });
    
    // $('#freq_bought_mob').slick({
    //   dots: true,
    //   infinite: true,
    //   speed: 300,
    //   slidesToShow: 2,
    //   slidesToScroll: 1,
    //   vertical:true,
    //   swipe:false,
    // });  
  
      //tabs
    // Show the first tab and hide the rest
      $('#tabs-nav li:first-child').addClass('active');
      $('.tab-content').hide();
      $('.tab-content:first').show();

      // Click function
      $('#tabs-nav li').click(function(){
        if($(this).hasClass("active")){
         $(this).removeClass("active")
         $('body').removeClass('filterStopScroll');
         $('#tabs-content').hide();
        }
        else{
        $('#tabs-nav li').removeClass('active');
        $(this).addClass('active');
         $('body').addClass('filterStopScroll');    
        $('#tabs-content').css('display','block')
        $('.tab-content').hide();

        var activeTab = $(this).find('a').attr('href');
        $(activeTab).fadeIn();
          return false;
        }
      });
    //popup 
    $(".show-popup-btn").click(function(){
      $("#modal-iphone").addClass("show-modal");
       $(".announcment-bar-desktop").addClass("announcment-visibility");
    });
    $(".close-popup").click(function(){
      $("#modal-iphone").removeClass("show-modal");
       $(".announcment-bar-desktop").removeClass("announcment-visibility");
    });
    $(".show-popup-modal").click(function(){
      $("#modal-macbook").addClass("show-modal");
      $(".announcment-bar-desktop").addClass("announcment-visibility");
    });
    $(".close-popup").click(function(){
      $("#modal-macbook").removeClass("show-modal");
      $(".announcment-bar-desktop").removeClass("announcment-visibility");
    });
    $(".show-popup-applewatch").click(function(){
      $("#modal-applewatch").addClass("show-modal");
      $(".announcment-bar-desktop").addClass("announcment-visibility");
    });
    $(".close-popup").click(function(){
      $("#modal-applewatch").removeClass("show-modal");
      $(".announcment-bar-desktop").removeClass("announcment-visibility");
    });
  
});
$(document).ready(function(){ 
    $('.image-zoom')
    .wrap('<span style="display:inline-block"></span>')
    .css('display', 'block')
    .parent()
    .zoom({
      url: $(this).find('img').attr('data-zoom')
    });
  $('.thumbnail-list').not('.prod-no-video').slick('slickSetOption', 'slidesToShow', 4);
});

setTimeout(function(){
    if($(window).width()>992){
      $('#zip_content').html($('#zip_data').html());

      $('body').on('click','#zip_content #partPayCalculatorWidget', function(){
        $('#zip_content #partPayCalculatorWidgetCurtain').addClass('visible');
        $('#zip_content #partPayCalculatorWidgetDialog').addClass('visible');
      });
      
      $('body').on('click', '#zip_content .partPayCalculatorCloseButton', function(){
      	$('#zip_content #partPayCalculatorWidgetCurtain').removeClass('visible');
        $('#zip_content #partPayCalculatorWidgetDialog').removeClass('visible');
      });
      
      $('.show-mob-only').html('');
    }else{
    	
    }
},1000);

//find-and-add-class
$(document).ready(function(){
  $(".price--sold-out").parent().parent().addClass('sold-outer');
});

$('body').find('.price--sold-out').parents('body').addClass('sold-main');

//on scroll add class for mobile
$(window).scroll(function(){
    if ($(this).scrollTop() > 200) {
       $('.product-page-cart').addClass('product-page-cart-sticky');
       $("#google-merchantwidget-iframe-wrapper").addClass("sticky-add-to-cart-visible");
       $("#google-merchantwidget-iframe-wrapper").css("bottom", "80px!important;");
       console.log("adding the 80");
    } else {
       $('.product-page-cart').removeClass('product-page-cart-sticky');
       $("#google-merchantwidget-iframe-wrapper").removeClass("sticky-add-to-cart-visible");
       $("#google-merchantwidget-iframe-wrapper").css("bottom", "19px!important;");
    }
});